/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type EscalationFilterBarrierOwnerQueryVariables = {||};
export type EscalationFilterBarrierOwnerQueryResponse = {|
  +viewer: {|
    +beds: {|
      +nodes: $ReadOnlyArray<{|
        +visit: ?{|
          +plan: ?{|
            +barriers: $ReadOnlyArray<?{|
              +owner: ?string
            |}>
          |}
        |}
      |}>
    |}
  |}
|};
export type EscalationFilterBarrierOwnerQuery = {|
  variables: EscalationFilterBarrierOwnerQueryVariables,
  response: EscalationFilterBarrierOwnerQueryResponse,
|};
*/


/*
query EscalationFilterBarrierOwnerQuery {
  viewer {
    beds(first: 10000, type: BARRIER) {
      nodes {
        visit {
          plan {
            barriers {
              owner
              id
            }
            id
          }
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "BARRIER"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "owner",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EscalationFilterBarrierOwnerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "BedConnection",
            "kind": "LinkedField",
            "name": "beds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Bed",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Visit",
                    "kind": "LinkedField",
                    "name": "visit",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Plan",
                        "kind": "LinkedField",
                        "name": "plan",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Barrier",
                            "kind": "LinkedField",
                            "name": "barriers",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "beds(first:10000,type:\"BARRIER\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EscalationFilterBarrierOwnerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "BedConnection",
            "kind": "LinkedField",
            "name": "beds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Bed",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Visit",
                    "kind": "LinkedField",
                    "name": "visit",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Plan",
                        "kind": "LinkedField",
                        "name": "plan",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Barrier",
                            "kind": "LinkedField",
                            "name": "barriers",
                            "plural": true,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "beds(first:10000,type:\"BARRIER\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be0a46a2a70587eb252a1f90560b439e",
    "id": null,
    "metadata": {},
    "name": "EscalationFilterBarrierOwnerQuery",
    "operationKind": "query",
    "text": "query EscalationFilterBarrierOwnerQuery {\n  viewer {\n    beds(first: 10000, type: BARRIER) {\n      nodes {\n        visit {\n          plan {\n            barriers {\n              owner\n              id\n            }\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'efb9a7f4e19d552eef562d3a81a80804';

module.exports = node;
